import Modal, { ModalBody, ModalHeader, Sheets } from '@ingka/modal';
import type { SelectedServices } from '@repo/api-adapters/selectors/services.selectors';

import { TimeWindowFooter } from './time-window-footer.component';
import { TimeWindowSelection } from './time-window-selection.component';

interface TimeWindowUpdateModalProps {
    readonly onClose: () => void;
    readonly selectedService: SelectedServices[number] | undefined;
}

export const TimeWindowUpdateModal = ({ onClose, selectedService }: TimeWindowUpdateModalProps) => {
    const selectedServiceName = selectedService?.serviceName ?? '';

    return (
        <Modal
            handleCloseBtn={onClose}
            visible={Boolean(selectedService)}
            onModalClosed={onClose}
            focusLockProps={{ autoFocusReturn: false }}
        >
            <Sheets
                aria-label={selectedServiceName}
                header={<ModalHeader title={selectedServiceName} />}
                footer={selectedService ? <TimeWindowFooter service={selectedService} onSuccess={onClose} /> : null}
            >
                <ModalBody>{selectedService && <TimeWindowSelection service={selectedService} />}</ModalBody>
            </Sheets>
        </Modal>
    );
};
